import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import config from '../config';
import { trackBookNow, trackPhoneClick } from '../analytics';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const handleBookNow = () => {
    // Track Book Now click in Google Analytics
    trackBookNow('header');
    
    // Redirect to House Call Pro lead form
    window.open(config.hcp.bookingUrl, '_blank');
  };

  return (
    <header className="fixed top-[44px] sm:top-[52px] left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src={config.assets.logos.vertical}
              alt={config.company.name}
              className="h-12 sm:h-14 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-[#2C60AC] transition-colors font-medium">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-[#2C60AC] transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('giftcard')} className="text-gray-700 hover:text-[#2C60AC] transition-colors font-medium">
              Gift Card
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-[#2C60AC] transition-colors font-medium">
              Why Choose Us
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-[#2C60AC] transition-colors font-medium">
              Testimonials
            </button>
            <a href={`tel:${config.contact.phone}`} className="flex items-center text-gray-700 hover:text-[#2C60AC] transition-colors font-medium" onClick={trackPhoneClick}>
              <Phone className="h-4 w-4 mr-2" />
              {config.contact.phoneDisplay}
            </a>
          </nav>

          {/* Book Now Button */}
          <div className="hidden md:block">
            <Button 
              onClick={handleBookNow}
              className="bg-[#28BCB7] hover:bg-[#65C6BA] text-white px-6 py-2 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg hover:scale-105"
            >
              Book Now
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-4 py-6 space-y-4">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left text-gray-700 hover:text-[#2C60AC] transition-colors font-medium py-2">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-gray-700 hover:text-[#2C60AC] transition-colors font-medium py-2">
              Services
            </button>
            <button onClick={() => scrollToSection('giftcard')} className="block w-full text-left text-gray-700 hover:text-[#2C60AC] transition-colors font-medium py-2">
              Gift Card
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left text-gray-700 hover:text-[#2C60AC] transition-colors font-medium py-2">
              Why Choose Us
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left text-gray-700 hover:text-[#2C60AC] transition-colors font-medium py-2">
              Testimonials
            </button>
            <a href={`tel:${config.contact.phone}`} className="flex items-center text-gray-700 hover:text-[#2C60AC] transition-colors font-medium py-2" onClick={trackPhoneClick}>
              <Phone className="h-4 w-4 mr-2" />
              {config.contact.phoneDisplay}
            </a>
            <Button 
              onClick={handleBookNow}
              className="w-full bg-[#28BCB7] hover:bg-[#65C6BA] text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300"
            >
              Book Now
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};